import * as Yup from 'yup'

export const InviteWorkersViaMessageSchema = Yup.object().shape({
  firstName: Yup.string().required('This field is required'),
  lastName: Yup.string().required('This field is required'),
  phone: Yup.string().required('This field is required'),
  email: Yup.string().required('This field is required'),
  collectDataTemplateId: Yup.string().required('Please choose an option'),
  partnerMarketId: Yup.string().required('Please choose an option'),
})
